import { spacing, colors } from '@mehilainen/mds-tokens';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { alertClasses, } from '@mui/material';
const getStandardColorStyles = (alertColor, tokens) => {
    var _a, _b;
    return {
        color: colors[alertColor][600],
        borderColor: (_b = (_a = tokens.uiElementAlert.borderColor) === null || _a === void 0 ? void 0 : _a[alertColor]) !== null && _b !== void 0 ? _b : colors[alertColor][500],
        backgroundColor: colors[alertColor][100],
        [`& > .${alertClasses.icon}`]: {
            backgroundColor: tokens.uiElementAlert.icon.standard.bgColor[alertColor],
            '& > svg': {
                color: tokens.uiElementAlert.icon.standard.color[alertColor],
            },
        },
    };
};
const getFilledColorStyles = (alertColor, tokens) => {
    return {
        borderColor: colors[alertColor][500],
        backgroundColor: colors[alertColor][500],
        [`& > .${alertClasses.icon} > svg`]: {
            color: tokens.uiElementAlert.icon.filled.color[alertColor],
        },
    };
};
export const getThemeAlert = (tokens) => ({
    MuiAlert: {
        defaultProps: {
            iconMapping: tokens.uiElementAlert.icon.iconMapping,
            variant: 'standard',
        },
        styleOverrides: {
            root: {
                alignItems: 'center',
                border: tokens.uiElementAlert.border,
                borderRadius: tokens.uiElementAlert.borderRadius,
                fontSize: baseTypography.size[200].rem,
                fontWeight: baseTypography.weight.Regular,
                gap: spacing[500].rem,
                lineHeight: tokens.uiElementAlert.lineHeight,
                padding: tokens.uiElementAlert.padding,
            },
            icon: {
                alignItems: 'center',
                alignSelf: 'baseline',
                borderRadius: tokens.uiElementAlert.icon.borderRadius,
                flexShrink: 0,
                height: tokens.uiElementAlert.icon.bgHeight,
                justifyContent: 'center',
                marginRight: 0,
                opacity: 1,
                padding: 0,
                width: tokens.uiElementAlert.icon.bgWidth,
                '& > svg': {
                    fontSize: baseTypography.size.icon[300].rem,
                },
            },
            standard: {
                [`&.${alertClasses.colorError}`]: Object.assign({}, getStandardColorStyles('Error', tokens)),
                [`&.${alertClasses.colorInfo}`]: Object.assign({}, getStandardColorStyles('Info', tokens)),
                [`&.${alertClasses.colorSuccess}`]: Object.assign({}, getStandardColorStyles('Success', tokens)),
                [`&.${alertClasses.colorWarning}`]: Object.assign({}, getStandardColorStyles('Warning', tokens)),
            },
            filled: {
                color: colors.White,
                [`& > .${alertClasses.icon}`]: {
                    backgroundColor: tokens.uiElementAlert.icon.filled.bgColor,
                },
                [`&.${alertClasses.colorError}`]: Object.assign({}, getFilledColorStyles('Error', tokens)),
                [`&.${alertClasses.colorInfo}`]: Object.assign({}, getFilledColorStyles('Info', tokens)),
                [`&.${alertClasses.colorSuccess}`]: Object.assign({}, getFilledColorStyles('Success', tokens)),
                [`&.${alertClasses.colorWarning}`]: Object.assign({}, getFilledColorStyles('Warning', tokens)),
            },
            message: {
                padding: 0,
            },
            action: {
                alignSelf: 'flex-start',
                marginRight: 0,
                padding: 0,
            },
        },
    },
    MuiSnackbar: {
        defaultProps: {
            autoHideDuration: 3000,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
        },
    },
    MuiAlertTitle: {
        styleOverrides: {
            root: {
                fontSize: baseTypography.size[300].rem,
                fontWeight: baseTypography.weight.Medium,
                lineHeight: baseTypography.height.Large,
                marginBottom: tokens.uiElementAlertTitle.marginBottom,
                marginTop: 0,
            },
        },
    },
});
